import './skeleton.css'

export const PeerListSkeletonLoader = () => (
  <div className='flex flex-col w-full'>
    <div className='w-full h-[20px] skeleton rounded-md mb-1'></div>
    <div className='flex gap-[4px] text-[#3D3D3D] pb-5'>
      <div className='w-[60px] h-[16px] skeleton rounded-md'></div>
      <div className='w-[80px] h-[16px] skeleton rounded-md'></div>
    </div>
    <hr className='skeleton' />
    <div className='pb-6'>
      <div className='space-y-4'>
        {[...Array(5)].map((_, index) => (
          <div key={index} className='w-full h-[40px] skeleton rounded-md'></div>
        ))}
      </div>
    </div>
  </div>
)
